module.exports = __webpack_public_path__ + "static/desktop/img/info-success.b689dd57.svg";